module.exports = __webpack_public_path__ + "img/activePhone.2244229c.gif";